import { Container } from '@chakra-ui/react';
import { GetServerSidePropsContext, NextPage } from 'next';

import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';

import Article from '@/components/Article';
import ArticleContent from '@/components/Article/articleContent';
import { H1 } from '@/components/Heading';
import Seo from '@/components/Seo';

import { LocaleProps } from '@/models/props/LocalizationProps';
import { AboutUsService } from '@/services/AboutUsService';

type AboutUsProps = {
    content: Record<string, string>;
};

const AboutUsPage: NextPage<AboutUsProps> = (props: AboutUsProps) => {
    const content = props.content;

    return (
        <>
            <Seo templateTitle={content.title} />
            <Container maxW="container.2xl">
                <Article>
                    <H1 textAlign="center">{content.title}</H1>
                    <ArticleContent content={content.content} />
                </Article>
            </Container>
        </>
    );
};

export const getServerSideProps = withCommonServerSideProps(
    async (context: GetServerSidePropsContext) => {
        const { locale } = context;
        let content;

        try {
            content = await AboutUsService.getAboutUs(locale as LocaleProps);
        } catch {
            content = [];
        }

        if (content.length === 0) {
            return {
                notFound: true
            };
        }

        return {
            props: {
                content
            }
        };
    }
);

export default AboutUsPage;
